import classnames from "classnames";
import { useTranslation } from "react-i18next";
import SVG from "react-inlinesvg";

import AlreadySubmittedIcon from "@krea/customer-features/images/svg/checkmark-with-background.svg";
import SubmitOnLenderSiteIcon from "@krea/customer-features/images/svg/external-with-background.svg";
import SubmitInNextStepIcon from "@krea/customer-features/images/svg/right-arrow-with-background.svg";
import { Text } from "@krea/customer-features/shared-components/text";
import {
  FieldRequestFieldEnum,
  IFieldRequest,
} from "@krea/customer-features/types/fieldRequest";
import { ILenderResponse } from "@krea/customer-features/types/lenderResponse";

const LenderResponseFieldRequestDetails = ({
  fieldRequests,
  lenderResponse,
}: {
  fieldRequests: IFieldRequest[];
  lenderResponse: ILenderResponse;
}) => {
  const { t } = useTranslation();

  const getImageSrc = (fieldRequest: IFieldRequest) => {
    if (fieldRequest.isCollectedByLender) {
      return SubmitOnLenderSiteIcon as string;
    } else if (fieldRequest.isSubmitted) {
      return AlreadySubmittedIcon as string;
    } else {
      return SubmitInNextStepIcon as string;
    }
  };

  const getText = (fieldRequest: IFieldRequest) => {
    if (fieldRequest.isCollectedByLender) {
      return t("bidDetails.submitToLenderSite");
    } else if (fieldRequest.isSubmitted) {
      return t("bidDetails.alreadySubmitted");
    } else {
      return t("bidDetails.submitInNextStep");
    }
  };

  return (
    <ul>
      {fieldRequests.map((fieldRequest, index) => (
        <li
          key={fieldRequest.id}
          className={classnames({
            "tw-mb-[10px] tw-border-b-2 tw-border-dotted tw-pb-[10px]":
              index != fieldRequests.length - 1,
          })}
        >
          <div className="md:tw-flex md:tw-justify-between">
            <Text size="sm" className="tw-flex tw-max-w-[355px] tw-font-bold">
              {fieldRequest.displayName}
            </Text>
            <div className="tw-mt-1 tw-inline-block tw-max-w-[200px] md:tw-min-w-[80px]">
              <div className="tw-flex tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 tw-pl-1 tw-pr-2 lg:tw-px-2">
                <SVG
                  src={getImageSrc(fieldRequest)}
                  className="tw-mr-1 tw-mt-[3px] tw-shrink-0"
                />
                <Text size="xs">{getText(fieldRequest)}</Text>
              </div>
            </div>
          </div>

          {fieldRequest.isCollectedByLender &&
            fieldRequest.field === FieldRequestFieldEnum.banking_data &&
            lenderResponse.lenderApplication.lenderCompany.name === "Froda" && (
              <Text size="sm" className="tw-mt-1 tw-text-gray-600">
                {t("bidDetails.collectedByLenderFieldRequestInfo")}
              </Text>
            )}
          {fieldRequest.lenderComment && (
            <Text size="sm" className="tw-mb-2 tw-mt-1 tw-font-normal">
              <span className="tw-text-gray-600">
                {t("bidDetails.lenderComment")}
              </span>
              {fieldRequest.lenderComment}
            </Text>
          )}
        </li>
      ))}
    </ul>
  );
};

export default LenderResponseFieldRequestDetails;
